import { useEffect, useState } from 'react';

type ThemeType = 'dark' | '';

const useTheme = () => {
  const [theme, setTheme] = useState<ThemeType>(() => 'dark');

  const applyTheme = (newTheme: ThemeType) => {
    document.documentElement.classList.toggle('dark', newTheme === 'dark');
    localStorage.setItem('theme', newTheme);
    setTheme(newTheme);
  };

  const toggleTheme = () => {
    applyTheme(theme !== 'dark' ? 'dark' : '');
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') as ThemeType;
    if (savedTheme) {
      applyTheme(savedTheme);
    } else {
      applyTheme('dark');
    }
  }, []);

  return {
    toggleTheme,
    theme,
  };
};

export default useTheme;
